import React, {Fragment} from 'react';
import REST from 'go/requests/rest';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {
  Segment,
  Header,
  Dropdown,
  Grid,
  Pagination,
  Confirm,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import {
  STATUS_PENDING_SUBMISSION,
  STATUS_SUBMITTED_TO_FEMA,
  STATUS_RETURNED_TO_RECIPIENT,
  STATUS_AMENDMENT_APPROVED,
  STATUS_AMENDMENT_DENIED,
  STATUS_AMENDMENT_WITHDRAWN,
  ASSOCIATED_AMENDMENT_STATUSES,
} from 'app-ui-componentlibrary/dist/common/constants';
import {convertDateForDisplay, getTimestampOfISO} from 'common/utils';
import {withRouter} from 'react-router-dom';
import {canViewPostAwardEntities} from 'go/security/permissions';

const AMENDMENT_PAGE_SIZE = 10;

export class AmendmentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      pageSize: AMENDMENT_PAGE_SIZE,
      entities: [],
      selectedEntity: {},
      open: false,
      showMessage: false,
    };
  }

  componentDidMount() {
    this.refreshData();
  }
  componentDidUpdate(prevProps) {
    const {data, amendments} = this.props;
    if (
      (data && data !== prevProps.data) ||
      !_.isEqual(amendments, prevProps.amendments)
    ) {
      this.refreshData();
    }
  }

  refreshData() {
    const {token, data: grantId, permissions, entities} = this.props;
    Promise.all(
      _.map(entities, (entityType) =>
       {
        if (entityType === 'subAmendmentRecommendation')
          return REST.dynamicData
            .getEntitiesBySubGrantIdAndEntityType(grantId, entityType)
            .then(REST.handler.handleResponse);
        else
          return REST.dynamicData
            .getAllByGrantIdAndEntityType(token, grantId, entityType)
            .then(REST.handler.handleResponse);
       })
    ).then((resp) => {
      let entities = _.flatMap(resp, (entity) => entity);
      if (!canViewPostAwardEntities(permissions)) {
        entities = _.reject(entities, (entity) => {
          return entity.status === STATUS_PENDING_SUBMISSION;
        });
      }
      entities.forEach((entity) => {
        entity.statusTimestamp = getTimestampOfISO(entity.statusTimestamp);
      });
      entities = _.orderBy(entities, ['statusTimestamp'], ['desc']);
      this.setState({entities: entities});
    });
  }
  onClose = () => this.setState({showMessage: false});

  show = () => this.setState({open: true});
  handleConfirm = () => {
    let entity = this.state.selectedEntity;
    let entities = this.props.amendments;
    var amendments = Object.values(entities);
    entity.status = 'withdrawn';
    REST.dynamicData
      .updateEntity(this.props.token, entity)
      .then(REST.handler.handleResponse)
      .then(() => {
        let index = _.findIndex(
          amendments,
          (result) => result.entityNumber === entity.entityNumber
        );
        let amendmentsEntity = (entity.entityType === 'subAmendmentRecommendation') ? 
          'subAmendmentRecommendationsForSubGrant' : 'amendments';
        this.props.saveEntitySessionData(`context.${amendmentsEntity}[${index}]`, entity);
        this.setState({
          showMessage: true,
          open: false,
        });
      });
  };

  handleCancel = () => this.setState({open: false});

  doEntityAction(actionType, entity) {
    let entityType = entity.entityType;
    let entityId = entity.entityId;
    switch (actionType) {
      case 'viewRequest':
        window.open(`/${entityType}/${entityId}/view`, '_blank');
        break;
      case 'viewAmendmentPackage':
        window.open(`/${entityType}/${entityId}/view`, '_blank');
        break;
      case 'viewDecision':
        window.open(`/${entityType}/${entityId}/view`, '_blank');
        break;
      case 'continue':
        this.props.history.push(`/${entityType}/${entityId}/edit`);
        break;
      case 'withdraw':
        this.setState({selectedEntity: entity}, () => this.show());
        break;
      default:
    }
  }

  renderAmendments() {
    const {permissions} = this.props;
    const {entities, activePage, pageSize} = this.state;
    const entitiesToRender = _.slice(
      entities,
      (activePage - 1) * pageSize,
      activePage * pageSize
    );
    return (
      <Grid
        key={'amendmentsGrid'}
        doubling
        stackable
        reversed="mobile"
        padded="vertically"
      >
        <Grid.Column className="visible-overflow">
          <FemaGoTable summary={'Amendment package'} type="static" columns={5}>
            <FemaGoTable.Header>
              <FemaGoTable.Row key="amendmentsTableHeader">
                <FemaGoTable.HeaderCell>Request number</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Request date</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Date of status</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(entitiesToRender, (entity, index) => {
                let actions = [];
                switch (entity.status) {
                  case STATUS_SUBMITTED_TO_FEMA:
                  case STATUS_AMENDMENT_WITHDRAWN:
                    actions.push({
                      key: 'viewRequest',
                      text: 'View request',
                      value: 'viewRequest',
                    });
                    break;
                  case STATUS_RETURNED_TO_RECIPIENT:
                    if (canViewPostAwardEntities(permissions)) {
                      actions.push({
                        key: 'continue',
                        text: 'Continue amendment ',
                        value: 'continue',
                      });
                      actions.push({
                        key: 'withdraw',
                        text: 'Withdraw request',
                        value: 'withdraw',
                      });
                    } else {
                      actions.push({
                        key: 'viewRequest',
                        text: 'View request',
                        value: 'viewRequest',
                      });
                    }
                    break;
                  case STATUS_PENDING_SUBMISSION:
                    actions.push({
                      key: 'withdraw',
                      text: 'Withdraw request',
                      value: 'withdraw',
                    });
                    actions.push({
                      key: 'continue',
                      text: 'Continue amendment ',
                      value: 'continue',
                    });
                    break;
                  case STATUS_AMENDMENT_APPROVED:
                    actions.push({
                      key: 'viewAmendmentPackage',
                      text: 'View amendment package',
                      value: 'viewAmendmentPackage',
                    });
                    break;
                  case STATUS_AMENDMENT_DENIED:
                    actions.push({
                      key: 'viewDecision',
                      text: 'View FEMA decision',
                      value: 'viewDecision',
                    });
                    break;
                  default:
                }

                return (
                  <FemaGoTable.Row key={`${entity.entityId}-row`}>
                    <FemaGoTable.TextCell>
                      {`${entity.entityType === 'subAmendmentRecommendation' ? 'amendment' : entity.entityType} ${entity.entityNumber}`}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {`${entity.status}` === STATUS_PENDING_SUBMISSION ||
                      `${entity.status}` === STATUS_AMENDMENT_WITHDRAWN
                        ? ''
                        : convertDateForDisplay(
                            _.get(entity, 'payload.request.date', entity.statusTimestamp)
                          )}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {ASSOCIATED_AMENDMENT_STATUSES[entity.status] || 'N/A'}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertDateForDisplay(entity.statusTimestamp)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {actions.length > 0 ? (
                        <Dropdown
                          selectOnNavigation={false}
                          selectOnBlur={false}
                          text={'Select action'}
                          name={`${entity.entityId}-action-button`}
                          id={`${entity.entityId}-action-button`}
                          onChange={(e, {name, value}) =>
                            this.doEntityAction(value, entity)
                          }
                          upward={_.size(entitiesToRender) - index < 3} // Dropdown for last two will open up
                          options={actions}
                          value={''}
                        />
                      ) : (
                        'No Actions available'
                      )}
                    </FemaGoTable.TextCell>
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
          {entities.length > AMENDMENT_PAGE_SIZE ? (
            <div className="pagination-wrapper pagination">
              <Pagination
                totalPages={Math.ceil(entities.length / AMENDMENT_PAGE_SIZE)}
                activePage={activePage}
                onPageChange={(e, data) => this.setState({activePage: data.activePage})}
              />
            </div>
          ) : (
            ''
          )}
        </Grid.Column>
      </Grid>
    );
  }

  render() {
    const {showMessage} = this.state;
    return (
      <React.Fragment>
        <Confirm
          open={this.state.open}
          cancelButton="No"
          confirmButton="Yes"
          content="Are you sure you want to withdraw your request?"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Segment>
          {showMessage ? (
            <Message
              success
              header="Success"
              content="Amendment has been withdrawn"
              onDismiss={this.onClose}
            />
          ) : null}
          <Header as={'h4'} content={'Amendments'} id={'Amendments'} />
          {this.renderAmendments()}
        </Segment>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
  };
};

export default connect(mapStateToProps, null)(withRouter(connectDynamic(AmendmentList)));
